import React from "react";
import PropTypes from "prop-types";
import { CardCVCElement } from "react-stripe-elements";
import InputLabel from "components/v3/input-label/InputLabel";
import stripeStyles from "components/v3/payment-form/stripeStyles";
import styles from "./styles.module.scss";

class CardCVC extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: {},
            empty: true
        };

        this._onChange = this._onChange.bind(this);
    }

    _onChange({ error, empty }) {
        this.props.onStripeError("cardCVC", error);

        this.setState({
            error: error || {},
            empty
        });
    }

    render() {
        const { error, empty } = this.state;
        const className = `${ styles.cvc } ${ empty ? styles.empty : "" } ${ error.message ? styles.error : "" }`;

        return (
            <div className={ className }>
                <div className={ styles.inputLabel }>
                    <InputLabel
                        name="cvc"
                        label={ error.message || "CVC" }
                    />
                </div>
                <CardCVCElement
                    style={ stripeStyles }
                    className="stripeInput"
                    placeholder="CVC/CVV"
                    onChange={ this._onChange }
                />
            </div>
        );
    }
}

CardCVC.propTypes = {
    onStripeError: PropTypes.func.isRequired
};

export default CardCVC;
